import { render, staticRenderFns } from "./DocumentAPI.vue?vue&type=template&id=e6e9d10c&scoped=true&"
import script from "./DocumentAPI.vue?vue&type=script&lang=js&"
export * from "./DocumentAPI.vue?vue&type=script&lang=js&"
import style0 from "./DocumentAPI.vue?vue&type=style&index=0&id=e6e9d10c&prod&scoped=true&lang=css&"
import style1 from "./DocumentAPI.vue?vue&type=style&index=1&id=e6e9d10c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6e9d10c",
  null
  
)

export default component.exports